module.exports = __webpack_public_path__ + "static/media/aws-skill-builder-white-color.257866ba.svg";